module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaDerecha-dd-ap-7bd55dda.png";